<template>
  <v-container fluid>
    <v-stepper class="mb-5" v-model="step">
      <v-stepper-header>
        <v-stepper-step  step="1">Customer Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step  step="2">Student Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step  step="3">Review Order</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step  step="4">Checkout</v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <v-card v-if="step == 1">
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <span class="mr-5">Already a member?</span>
        <router-link to="login">Sign In</router-link>
        <v-spacer></v-spacer>
      </v-card-actions> -->
      <v-card-text>
        <div class="d-lg-none mb-5">Customer Info</div>
        <v-form ref="customerForm">
          <v-text-field
            label="First Name"
            v-model="customerInfo.firstName"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field label="Last Name" v-model="customerInfo.lastName" :rules="[rules.required]"></v-text-field>
          <v-text-field
            label="Email"
            v-model="customerInfo.email"
            :rules="[rules.required,rules.emailMatch]"
          ></v-text-field>
          <v-text-field label="Phone" v-mask="'+1(###) ###-####'" v-model="customerInfo.phone" :rules="[rules.phoneMatch]"></v-text-field>
        </v-form>
        <div class="d-flex flex-row my-5">
          <v-btn class="ml-auto primary" @click="saveCustomer">Next</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-card v-if="step == 2">
      <v-alert
        class="warning"
        v-if="!order.orderId"
      >Please enter customer info first</v-alert>
      <v-card-text>
        <div class="d-lg-none mb-5">Student Info</div>
        <v-form ref="studentForm">
          <student-form v-for=" (student, index) in students " :student.sync="student" :index="students.length > 1 ? index:-1" :key="index" @delete="deleteStudent" />
        </v-form>
        <div class="d-flex flex-row my-5">
          <v-btn v-if="students && totalQuantity > students.length" class="mx-auto" @click="addAnotherStudent">Add Another Student</v-btn>
        </div>
        <div class="d-flex flex-row my-5">
          <v-btn class="mr-auto" @click="step = 1">Back</v-btn>
          <v-btn class="ml-auto primary" @click="saveStudents">Next</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-card v-if="step == 3">
      <v-alert
        class="warning"
        v-if="savedStudents.length < 1"
      >Please enter student info first</v-alert>
      <v-card-text>
        <div class="d-lg-none mb-5">Review Order</div>
        <v-form ref="courseAssignmentForm">
          <h4 class="my-2" v-if="courses && courses.length > 1">Please choose the student to it's corresponding course below.</h4>
          <v-card class="mb-5" v-for=" (course, index) in courses" :key="index">
            <v-card-title>{{course.name}}
              <v-btn v-if="courses && courses.length > 1" class="ml-auto" icon>
               <v-icon  @click="removeCourse(course)">mdi-delete</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-subtitle>
              <div>
                Price: {{course.subTotal | currency}}
              </div>
              <div v-if="course.weeks">
                <br />Selected Weeks:
                <br />
                <br />
                <v-chip
                  class="mr-5 mb-5"
                  v-for=" (w, index) in course.weeks"
                  :key="index"
                >{{formatDate(w.week.start)}} - {{ formatDate(w.week.end) }}</v-chip>
              </div>
              
            </v-card-subtitle>
            <v-card-text>
              <v-text-field
                v-if="students.length == 1"
                label="Student for this course"
                readonly
                v-model="students[0].firstName"
              ></v-text-field>
              <v-select
                label="Choose student for this course"
                v-if="students.length > 1"
                :items="savedStudents"
                item-text="firstName"
                item-value="id"
                v-model="course.studentId"
                :rules="[rules.required]"
                clearable
              ></v-select>
            </v-card-text>
          </v-card>
          <div class="d-flex flex-row my-5">
            <v-btn class="mr-auto" @click="step = 2">Back</v-btn>
            <v-btn class="primary ml-auto" @click="assignCourses">Next</v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card v-if="step == 4">
      <v-card-text>
        <h4 class="mb-4">Order Summary</h4>
        <v-data-table
          :hide-default-footer="true"
          :headers="headers"
          :items="cartItemList"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:headers.subtotal="{ header }">
            {{header.value}}
          </template>

          <template v-slot:item.subtotal="{ item }">
            <span v-if="item.subject == 'Camp'">
              {{item.pricePerWeek * item.weeks.length | currency}}
            </span>
            <span v-else>
              {{item.pricePerCourse | currency}}
            </span>
          </template>

          <template v-slot:item.name="{ item }">
            <strong>{{item.name}}</strong>
          </template>

          <template v-slot:item.price="{ item }">
            <span v-if="item.subject == 'Camp'">
              {{item.pricePerWeek | currency}}/week
            </span>
            <span v-else>
              {{item.pricePerSession | currency}}/session
            </span>
          </template>

          <template v-slot:item.quantity="{ item }">
            {{item.quantity}}
            <span v-if="item.subject == 'Camp'">
              ({{item.weeks.length}} weeks)
            </span>
          </template>
        </v-data-table>
        <div class="ma-4">
          <v-row>
            <v-col >
              <strong>Total: {{ cartValue | currency }}</strong>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
<hr/>
      <v-card-text>
        <h4>Payment info</h4>
        <v-form ref="paymentForm">
          <v-text-field label="First Name"></v-text-field>
          <v-text-field label="Last Name"></v-text-field>
          <div id="ccnumber"></div>
          <div id="ccexp"></div>
          <div id="cvv"></div>

          <div v-if="paymentToken" class="my-5" >
            <h3 style="color: green">Credit card info entered</h3>
          </div>
          <!-- Use credit # 4111 1111 1111 1111 for testing,  any date and cvv value -->
          <v-btn
            @click="enterCCInfo"
          >{{paymentToken ? 'Update Credit Card Info':'Enter Credit Card Info Securely'}}</v-btn>
        </v-form>

        <hr class="my-5" />

        <h4>Our service pledge</h4>
        <div class="my-5 terms">
          <pre>
Sylvan Service Pledge
Our ultimate goal is to achieve 100% customer satisfaction. We pledge to use our best efforts and all reasonable means to meet this goal. We are always available to answer any questions you may have about your child's program, progress, teachers, center procedures, or any other issues. We are committed to making a difference in your child's future.

Online Group Tutoring
We recommend that students attend every session. Irregular attendance may be detrimental to your child's academic growth. There are no make-ups for our online group classes.

Online 1:1 Tutoring
For optimal results we recommend students attend a minimum of 2-6 sessions per week, per subject. Irregular attendance or early withdrawal may be detrimental to your child's academic growth. To ensure academic goals are achieved in the desired time frame, we will excuse a maximum of 2 absences per month for emergencies and illness.  The center must be notified by 12pm the day before to excuse any sessions.  We will work with you to reschedule these make-up sessions. You will be charged for no-shows or unexcused absences, and no make-ups will be provided in these cases.
        </pre>
        </div>
        <v-checkbox v-model="agreeTerms" label="We really want to make sure you understand our policies before enrolling. Please take 2 minutes to read them and mark here that you understand."></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="step = 3">Back</v-btn>
        <v-spacer></v-spacer>
        <v-btn id="confirmAndSubmitPayment" :disabled="loading || !agreeTerms" @click="checkout" class="primary">Confirm and Submit</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
const StudentForm = () => import('@/components/checkout/StudentForm.vue')
import {mask} from 'vue-the-mask'

// import CollectJS from 'collectjs';

export default {
  name: "Home",
  data: () => ({
    step: 1,
    loading: false,
    customerInfo: null,
    students: [],
    courses: [],
    savedStudents: [],
    totalQuantity: 0,
    summaryHeaders: [
      { text: "Course", value: "name", align: "start", sortable: false },
      { text: "Price", value: "price", align: "start", sortable: false },
      { text: "Quanity", value: "quantity", align: "start", sortable: false }
    ],
    reviewComplete: true,
    customerInfoComplete: true,
    studentInfoComplete: false,
    checkoutComplete: false,
    rules: {
      required: value => !!value || "This field is required",
      emailMatch: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      phoneMatch: value => {
        if(value){
          const phoneNumber = value.replace(/\D/g,'');
          const invalidLength = phoneNumber.length < 10 || phoneNumber > 11;
          
          return invalidLength || "Invalid phone number"
        }
        else{
          //Not required
          return true;
        }
      }
    },
    agreeTerms: false,
    paymentToken: null,
    headers: [
      { text: "Course", value: "name", align: "start", sortable: false },
      { text: "Unit Price", value: "price", align: "start", sortable: false },
      { text: "Quanity", value: "quantity", align: "start", sortable: false },
      { text: "Subtotal", value: "subtotal", align: "start", sortable: false },
    ]
  }),
  components: {
    StudentForm
  },
  watch: {
    students(newStudents){
      if(newStudents){
        this.savedStudents = newStudents.filter(s => s.id);
      }
      else{
        this.savedStudents = [];
      }
    }
  },
  computed: {
    ...mapGetters([
      "cartItemList",
      "isLoggedIn",
      "currentUser",
      "cartValue",
      "order",
    ]),
  },
  directives: {mask},
  created() {
    this.customerInfo = this.order.customerInfo;
    if ( !this.order.students || this.order.students.length < 1) {
      this.students = [
        {
          id: "",
          firstName: "",
          lastName: "",
          email: "",
          grade: null,
          dob: "",
          showDob: false,
          relationship: null
        }
      ];
    } else {
      this.students = this.order.students;
    }

    this.loadCoursesFromCart();
  },
  mounted() {
    //add alert if no course in cart
    if (this.courses && this.courses.length < 1) {
      this.addErrorMessage("Please choose a course before checking out.");
    }

    const _this = this;

    //add Collect.js to document Head
    this.loadCollectJs().then(script => {
      console.log(`Loaded Collect.js`);
      console.log(script);
      window.CollectJS.configure({
        paymentSelector: "#payButton",
        theme: "material",
        primaryColor: "#1976d2",
        // secondaryColor: "#ffe200",
        buttonText: "Submit",
        instructionText: "Enter Card Info Below",
        paymentType: "cc",
        fields: {
          ccnumber: {
            selector: "#demoCcnumber",
            title: "Card Number",
            placeholder: "0000 0000 0000 0000"
          },
          ccexp: {
            selector: "#demoCcexp",
            title: "Card Expiration",
            placeholder: "00 / 00"
          },
          cvv: {
            display: "show",
            selector: "#demoCvv",
            title: "CVV Code",
            placeholder: "***"
          }
        },
        callback: function(response) {
          _this.paymentToken = response.token;
          console.log(`Payment Token: ${_this.paymentToken}`);

          // var input = document.createElement("input");
          // input.type = "hidden";
          // input.name = "payment_token";
          // input.value = response.token;
          // var form = document.getElementsByTagName("form")[0];
          // form.appendChild(input);
          // form.submit();
        },
        fieldsAvailableCallback: function() {
          console.log("Collect.js loaded the fields onto the form");
        }
      });
    });
  },
  methods: {
    ...mapActions([
      "addMessage",
      "addErrorMessage",
      "clearMessage",
      "updateOrder",
      "addStudents",
      "removeStudents",
      "updateCourseAssignments",
      "clearCart",
      "clearOrder",
      "clearCourses",
      "removeItemInCart",
      "updateCart"
    ]),
    studentName(studentId){
      if(this.students){
        const student = this.students.find(s => s.id == studentId);
        return `${student.firstName} ${student.lastName}`
      }
      else{
        return 'N/A';
      }
    },
    loadCoursesFromCart(){
      //convert cart items to list of courses, duplicate cart item if quantity is greater than 1
      this.clearCourses();
      this.courses = [];

      let totalQuantity = 0;
      this.cartItemList.forEach(item => {
        let studentId;

        if(this.students && this.students.length > 0){
          const studentsWithIds = this.students.filter(s => s.id);
          if(studentsWithIds && studentsWithIds.length > 0){
            studentId = studentsWithIds[0].id;
          }
        }

        if (this.order && this.order.courses) {
          const vuexCourse = this.order.courses.find(c => c.id == item.id);
          if(vuexCourse){
            studentId = vuexCourse.studentId;
          }
        }
        
        for (let i = 0; i < item.quantity; i++) {
          totalQuantity++;
          //Calculate subtotal
          const numberOfWeeks = item.weeks.length;
          const subTotal = (item.pricePerWeek || 0) * numberOfWeeks;
          this.courses.push({
            id: item.id,
            name: item.name,
            description: item.description,
            price: item.price,
            quantity: item.quantity,
            weeks: item.weeks,
            studentId: studentId,
            subTotal: subTotal
          });
        }
      });

      this.totalQuantity = totalQuantity;
    },
    loadCollectJs() {
      const collectJsSrc =
        "https://secure.bngpaymentgateway.com/token/Collect.js";
      return new Promise((resolve, reject) => {
        // Create script element and set attributes
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = collectJsSrc;
        script.setAttribute(
          "data-tokenization-key",
          "9KFJ9C-kxyDAY-38m5E3-dfJ2Nz"
        );

        // Append the script to the DOM
        const el = document.getElementsByTagName("script")[0];
        el.parentNode.insertBefore(script, el);

        // Resolve the promise once the script is loaded
        script.addEventListener("load", () => {
          this.isLoaded = true;
          resolve(script);
        });

        // Catch any errors while loading the script
        script.addEventListener("error", () => {
          reject(new Error(`${this.src} failed to load.`));
        });
      });
    },
    enterCCInfo() {
      window.CollectJS.startPaymentRequest();
    },
    saveCustomer() {
      if (!this.$refs.customerForm.validate()) return;

      const orderId = this.order.orderId;

      if(this.customerInfo.phone){
        //strip all non-numeric from phone number
        const phoneNumber = this.customerInfo.phone.replace(/\D/g,'');
        console.log(phoneNumber + " " + phoneNumber.length)
        if(phoneNumber.length < 10 || phoneNumber.length > 11){
          this.addErrorMessage("Invalid phone number");
          return;
        }

        this.customerInfo.phone = phoneNumber;
      }

      const data = Object.assign({}, this.customerInfo);
      const params = {
        orderId: orderId
      };

      this.$axios
        .post("public/course-registration/add-rp", data, {params})
        .then(resp => {
          const responseOrder = resp.data;
          responseOrder.customerInfo = this.customerInfo;
          this.updateOrder(responseOrder);

          //Move onto step 2
          this.step = 2;
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
    addAnotherStudent() {
      const newStudent = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        grade: null,
        dob: "",
        showDob: false,
        relationship: null
      };
      this.students.push(newStudent);

      // this.saveStudents();
    },
    formatDate(date) {
      return moment(date).format("ddd, MM/DD/YYYY");
    },
    removeCourse(course){
      //find cart item using course
      const cartItem = this.cartItemList.find(item => item.id = course.id);
      console.log(cartItem)
      if(cartItem && cartItem.quantity == 1){
        //remove item from cart
        this.removeItemInCart({item: cartItem});
      }
      else if(cartItem && cartItem.quantity > 1){
        //reduce quantity of cart item in cart
        const newQuantity = cartItem.quantity -1;
        this.updateCart({item: cartItem, quantity: newQuantity});
      }

      this.loadCoursesFromCart();
    },
    deleteStudent(index) {
      console.log(`deleting student on index ${index}`);
      const orderId = this.order.orderId;
      const student = this.students[index];
      this.removeStudents([student]);

      //post delete if student id is not null
      if (student.id) {
        const data = {};
        const params = {
          studentId: student.id,
          orderId: orderId
        };
        this.$axios
          .post("/public/course-registration/unregister-student", data, {
            params
          })
          .then(resp => {
            console.log(resp);
          });
      }

      this.students.splice(index, 1);
    },
    saveStudents() {
      const orderId = this.order.orderId;
      console.log(`saving students for order ID: ${orderId}`);
      //Check if order id is available
      if (!orderId) {
        this.addErrorMessage("Please enter customer info first");
        return;
      }
      if (!this.$refs.studentForm.validate()) return;

      const posts = [];
      this.students.forEach(s => {
        const data = {
          firstName: s.firstName,
          lastName: s.lastName,
          grade: s.grade,
          dob: s.dob,
          email: s.email,
          relationship: s.relationship
        };
        const params = {
          orderId: orderId
        };
        const addStudent = this.$axios.post(
          "public/course-registration/add-students",
          data,
          {
            params
          }
        );
        posts.push(addStudent);
      });

      const _this = this;
      Promise.all(posts)
        .then(function(results) {
          results.forEach(function(resp) {
            //Save the order response with more students.
            console.log(resp);
            const students = resp.data.students;
            //format dob to string
            students.forEach(s => {
              if(s.dob){
                s.dob = moment(s.dob).format('YYYY-MM-DD');
              }
            })
            _this.addStudents(students);
          });

          _this.students = _this.order.students; //sync local
          //assign student to course if course doesn't have a student assigned
          _this.courses.forEach( c => {
            if(!c.studentId){
              c.studentId = _this.students[0].id;
            }
          })

          //Move onto next step
          _this.step = 3;
        })
        .catch(errors => {
          console.log(`Response error Message ${errors.message}`);
          this.addErrorMessage(errors.message);
        });

    },
    assignCourses() {
      if (!this.order || !this.order.orderId) {
        this.addErrorMessage("Please enter customer info first");
        return;
      }

      if (!this.$refs.courseAssignmentForm.validate()) return;
      //TODO:  Need to validate all courses has student assigned
      //Alert if any student has not been assigned a course
      //Check if student has no ID.

      const posts = [];
      this.courses.forEach(c => {
        console.log(c)
        const studentToCourses = {};
        const scheduleIds = c.weeks.flatMap(w => w.schedules);
        studentToCourses[c.studentId] = [{ courseId: c.id, scheduleIds }];
        const data = {
          studentToCourses
        };
        const params = {
          orderId: this.order.orderId
        };
        const postRequest = this.$axios.post(
          "/public/course-registration/assign-course",
          data,
          {
            params
          }
        );
        posts.push(postRequest);
      });

      const _this = this;
      Promise.all(posts)
        .then(function(results) {
          results.forEach(function(resp) {
            console.log(resp.data);
          });
          _this.updateCourseAssignments(_this.order.courses);
          _this.step = 4;
        })
        .catch(errors => {
          this.addErrorMessage(errors.message);
        });

    },
    checkout() {
      if (!this.order || !this.order.orderId) {
        this.addErrorMessage("Please enter customer info first");
        return;
      }

      if (!this.paymentToken) {
        this.addErrorMessage("Please enter payment info first");
        return;
      }

      if (!this.agreeTerms) {
        this.addErrorMessage(
          "Please read and agree to our service pledge first"
        );
        return;
      }

    this.loading = true;
    this.addMessage('Your order is being process, please wait...');

      const params = {
        orderId: this.order.orderId,
        paymentToken: this.paymentToken,
      };
      const data = {};
      this.$axios
        .post("/public/course-registration/checkout", data, { params })
        .then(resp => {
          console.log(resp);
          //clear vuex order value
          this.clearOrder();
          //Clear shopping cart
          this.clearCart();

          this.loading =false;
          //forward to confirmation page
          this.$router.push("/order/confirmation");
        })
        .catch(error => {
          this.loading =false;
          console.log(error.data.message)
          this.addErrorMessage(error.data.message);
        });
    }
  }
};
</script>

<style scoped>
.terms {
  height: 200px;
  overflow: auto;
  border: thin solid;
  padding: 5px;
}
.terms pre {
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>